<template>
  <v-card min-height="550">
    <col-skeleton-loader v-if="loading" :clms="6"></col-skeleton-loader>
    <v-row width="100%" v-if="!loading">
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.dailyProteinYield") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.amountProteinMilkCowDay")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.proteinYield
                    }}<span class="ml-2 text-h6 font-weight-light">
                      {{ animal.proteinYieldUom }}</span
                    >
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.dailyMilkYield") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.volumeMilkCowDay")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.milkYield
                    }}<span class="ml-2 text-h6 font-weight-light">{{
                      animal.milkYieldUom
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.dailyFatYield") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.amountFatMilkCowDay")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.fatYield
                    }}<span class="ml-2 text-h6 font-weight-light">{{
                      animal.fatYieldUom
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.milkLactose") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.amountLactoseMilk")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.milkLactose
                    }}<span class="ml-2 text-h6 font-weight-light">%</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.milkUrea") }} 
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.indicatorAmountCrudeProtein")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.milkUrea
                    }}<span class="ml-2 text-h6 font-weight-light">mg/dL</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.lactationNumber") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.ordinalNumLactation")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.lactationNo
                    }}<span class="ml-2 text-h6 font-weight-light"></span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.lengthOfLactation") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.lactationLength")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{ animal.lactationLength
                    }}<span class="ml-2 text-h6 font-weight-light">{{
                      animal.lactationLength > 1 ? $t("days") : $t("day")
                    }}</span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
      <v-col cols="6">
        <v-card class="pa-2 green2 elevation-0">
          <!-- <v-icon class="float-right">mdi-dots-horizontal</v-icon> -->
          <v-list class="green2">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-subtitle class="text-capitalize"
                  >{{ $t("animal.performanceInfo.milkingFrequency") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t("animal.performanceInfo.frequcnyOfMilking")
                    }}</span>
                  </v-tooltip>
                </v-list-item-subtitle>
                <v-list-item-title class="text-h6 mt-2">
                  <div class="text-h6 font-weight-bolder">
                    {{
                      animal.milkingFrequency
                        ? animal.milkingFrequency
                        :  $t('notSpecified')
                    }}
                    {{
                      animal.milkingFrequency
                        ? animal.milkingFrequency > 1
                          ? "times"
                          : "time"
                        : ""
                    }}
                    {{ animal.milkingFrequency ? $t("aDay") : ""
                    }}<span class="ml-2 text-h6 font-weight-light"></span>
                  </div>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
import ColSkeletonLoader from "@/components/col-skeleton-loader.vue";

export default {
  created() {
    // if(this.animal  && Object.keys(this.animal).length === 0)
    //    console.log('empty')
  },
  components: {
    ColSkeletonLoader,
  },
  computed: {
    ...mapGetters(["currentAnimal"]),
  },
  watch: {
    animal: function() {
      this.loading = false;
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  props: ["animal"],
};
</script>
